import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
export const selectRoom = createAction(`${reduxKey}.DAMZ_SELECT_ROOM`, (room_id)=>({
        room_id
    }));
export const setActiveRoomData = createAction(`${reduxKey}.DAMZ_SET_ROOM_DATA`, (roomRow)=>({
        roomRow
    }));
export const fetchMessagePrev = createCallbackActionCreator(`${reduxKey}.DAMZ_MESSAGE_FETCH_PREV`);
export const fetchMessageNext = createCallbackActionCreator(`${reduxKey}.DAMZ_MESSAGE_FETCH_NEXT`);
export const presenceJoin = createAction(`${reduxKey}.ROOM_PRESENCE_JOIN`, (room_id, joiners)=>({
        room_id,
        joiners
    }));
export const presenceLeave = createAction(`${reduxKey}.ROOM_PRESENCE_LEAVE`, (room_id, leavers)=>({
        room_id,
        leavers
    }));
export const sendMessage = createAction(`${reduxKey}.ROOM_MSG_SEND`, ()=>({}));
export const markRoomRead = createAction(`${reduxKey}.ROOM_MARK_READ`, (room_id)=>({
        room_id
    }));
export const markRoomReadSync = createAction(`${reduxKey}.ROOM_MARK_READ_SYNC`, ()=>({}));
export const markRoomReadSyncDone = createAction(`${reduxKey}.ROOM_MARK_READ_SYNC_DONE`, ()=>({}));
/**
 * Will start our process for focusing the user's view on a specific message. Handling differs between messages that are
 * already present in memory and messages we'll have to fetch from the network.
 */ export const requestFocusOnMessage = createAction(`${reduxKey}.REQUEST_FOCUS_ON_MESSAGE`, (messageId, sentAt)=>({
        messageId,
        sentAt
    }));
/**
 * Will let redux know that the message the user wants focused is ready to be scrolled to.
 *
 * IMPORTANT: Only to be used in sagas as part of the {@link requestFocusOnMessage} flow. Will not work on its own.
 */ export const scrollToRequestedMessage = createAction(`${reduxKey}.SCROLL_TO_REQUESTED_MESSAGE`, (shouldDropOtherMessages)=>({
        shouldDropOtherMessages
    }));
export const setUserTyping = createAction(`${reduxKey}.ROOM_SET_USER_TYPING`, ()=>({}));
export const maybeDisplayTypingIndicator = createAction(`${reduxKey}.ROOM_TYPING_MAYBE`, (state)=>({
        state
    }));
export const stopTyping = createAction(`${reduxKey}.ROOM_STOP_TYPING`, ()=>({}));
export const setTypingText = createAction(`${reduxKey}.ROOM_SET_TYPING_TEXT`, (text)=>({
        text
    }));
export const stopTypingLater = createAction(`${reduxKey}.ROOM_STOP_TYPING_LATER`, ()=>({}));
export const incrementMessageSent = createAction(`${reduxKey}.ROOM_MSG_SENT_INC`, ()=>({}));

//# sourceMappingURL=room.js.map